var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPs = function SvgPs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EDEEEF",
    d: "M6.1 0c-.825 0-1.5.675-1.5 1.5v21c0 .825.675 1.5 1.5 1.5h15c.825 0 1.5-.675 1.5-1.5V6l-6-6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B0B7BD",
    d: "M18.1 6h4.5l-6-6v4.5c0 .825.675 1.5 1.5 1.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M22.6 10.5 18.1 6h4.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7B84E",
    d: "M19.6 19.5c0 .413-.337.75-.75.75H2.35a.75.75 0 0 1-.75-.75V12c0-.412.338-.75.75-.75h16.5c.413 0 .75.338.75.75z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.117 14.21c0-.198.156-.415.408-.415H8.91c.78 0 1.482.523 1.482 1.524 0 .948-.702 1.475-1.482 1.475h-1v.792c0 .265-.169.414-.385.414a.405.405 0 0 1-.408-.414zm.792.341v1.494H8.91c.402 0 .72-.354.72-.726 0-.42-.318-.768-.72-.768zM11.07 14.75c.138-1.164 1.895-1.373 2.723-.737.408.33-.024.851-.384.587-.444-.282-1.451-.414-1.577.21-.162.983 2.446.42 2.404 2.015-.042 1.523-2.248 1.559-3.076.875a.44.44 0 0 1-.084-.587c.156-.155.329-.21.534-.042.49.336 1.757.588 1.846-.265-.077-.887-2.572-.353-2.386-2.057"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CAD1D8",
    d: "M18.85 20.25H4.6V21h14.25c.413 0 .75-.337.75-.75v-.75c0 .413-.337.75-.75.75"
  })));
};
export default SvgPs;